import { render, staticRenderFns } from "./ImportedDataTableCard.vue?vue&type=template&id=973584e4&scoped=true&"
import script from "./ImportedDataTableCard.vue?vue&type=script&lang=js&"
export * from "./ImportedDataTableCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportedDataTableCard.vue?vue&type=style&index=0&id=973584e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973584e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDataTable,VIcon})
